<template>
  <section class="fe-doc" aria-labelledby="firma-escrituras-documentation-title">
    <div class="fe-doc__content">
      <span class="fe-doc__tag">Documentación</span>

      <div class="fe-doc__text">
        <h2 id="firma-escrituras-documentation-title" class="fe-doc__title">Lo que necesitarás para tu proceso</h2>
        <p class="wd-body">
          Reúne esta documentación para que tu proceso avance <br class="br-d">sin contratiempos.
        </p>
      </div>

      <ul class="fe-doc__items">
        <li v-for="item in items" :key="item.icon" class="fe-doc__item">
          <img :src="item.icon" alt="" aria-hidden="true">
          <span class="wd-body" v-html="item.text" />
        </li>
      </ul>
    </div>

    <div class="fe-doc__media">
      <img class="fe-doc__image" :src="image" alt="Pareja sentada en el piso de su nueva casa">
    </div>
  </section>
</template>

<script setup lang="ts">
import image from '../../../assets/firma-escrituras-figma/documentacion.jpg'
import idIcon from '../../../assets/firma-escrituras-figma/doc-id.svg'
import taxIcon from '../../../assets/firma-escrituras-figma/doc-tax.svg'
import usersIcon from '../../../assets/firma-escrituras-figma/doc-users.svg'

const items = [
  { icon: idIcon, text: 'Identificación oficial original <br class="br-tm">y vigente (INE o pasaporte)' },
  { icon: taxIcon, text: 'Constancia de Situación Fiscal de los involucrados' },
  { icon: usersIcon, text: 'Asistencia obligatoria de todas las partes involucradas en la operación (Vendedor y titulares de contrato)' }
]
</script>

<style scoped>
.fe-doc { display: flex; align-items: stretch; gap: var(--ds-space-5); }

.fe-doc__content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--ds-space-5);
  min-width: 0;
}

.fe-doc__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.fe-doc__text { display: flex; flex-direction: column; gap: var(--ds-space-3); width: 100%; }
.fe-doc__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.fe-doc__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.fe-doc__item { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 40px; }
.fe-doc__item img { flex: 0 0 40px; width: 40px; height: 40px; object-fit: contain; }

/* La imagen se posiciona sobre el contenedor para que su alto intrínseco no estire la sección */
.fe-doc__media { position: relative; flex: 0 0 370px; min-width: 0; min-height: 454px; border-radius: 24px; overflow: hidden; }
.fe-doc__image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }

@media (max-width: 1024px) {
  .fe-doc__content { flex: 0 0 316px; }
  .fe-doc__media { flex: 1 1 0; min-height: 460px; }
}

@media (max-width: 599px) {
  .fe-doc { flex-direction: column-reverse; padding: var(--ds-space-5) 0; }
  .fe-doc__content { flex: none; justify-content: flex-start; width: 100%; padding: 0 var(--ds-space-3); box-sizing: border-box; }
  .fe-doc__media { flex: none; width: 100%; min-height: 0; aspect-ratio: 1 / 1; }
}
</style>
